import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OrderEntry, WishListService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable } from 'rxjs';
import { ProductService } from '../../product/service/product.service';

@Component({
  selector: 'cx-wish-list',
  templateUrl: './wish-eklist.component.html',
  styleUrls: ['./wish-eklist.component.scss'],
})
export class WishEklistComponent implements OnInit {
  userId: any;
  wishList: any;
  loading$: Observable<boolean> = this.wishListFacade.getWishListLoading();

  public cartEntry: any;
  constructor(
    protected wishListFacade: WishListService,
    protected productService: ProductService,
    protected userAccount: UserAccountFacade,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.userAccount.get().subscribe((resp) => {
      this.userId = resp?.uid;
      if (this.userId) {
        this.productService
          .getWishlistResults(this.userId)
          .subscribe((resp) => {
            resp.entries = resp.entries.filter(
              ( obj: {}) => !(obj && Object.keys(obj).length === 0)
            );
            console.log('xxx',resp)
            this.wishList = resp;
            this.cd.detectChanges();
          });
      }
    });
  }

  removeItem(cartEntry: OrderEntry) {
    this.productService
      .removeWishlistEntry(this.userId, cartEntry)
      .subscribe((resp) => {
        this.wishList = resp;
        this.cd.detectChanges();
      });
  }
}
